// extracted by mini-css-extract-plugin
export default {"productList":"css-85yOqvZ0B7"};